import type {
  IContractDocument,
  IContractUploadDocument,
} from '~/types/document/models'
import { makeDocumentService } from '~/cynqueModules/factoriesForServices/documents'

export const {
  createDocument: createContractDocument,
  updateDocument: updateContractDocument,
  deleteDocument: deleteContractDocument,
} = makeDocumentService<IContractDocument, IContractUploadDocument>(
  '/api/contractdocuments',
  'contractDocument'
)
